import { describeMutation } from '@siteless/resource';
import {
  BrowserStorageResource,
  BrowserStorageResourceType,
  writeBrowserStorage as writeBrowserStorageRaw
} from './BrowserStorage';

export let writeBrowserStorage = describeMutation(
  'writeBrowserStorage',
  async (
    writeWith: (last: BrowserStorageResourceType) => BrowserStorageResourceType,
  ) => {
    await writeBrowserStorageRaw(writeWith);

    await BrowserStorageResource.refresh(undefined);
  },
);
